export default __webpack_public_path__ + "static/media/eloquence.1b0bab59.jpg";